import { useEffect } from 'react'
import * as Sentry from '@sentry/tanstackstart-react'
import { createFileRoute, type ErrorComponentProps } from '@tanstack/react-router'
import AuthGuard from '../components/AuthGuard'
import HelperAppClient from '../components/HelperAppClient'

function HelperAppError({ error }: ErrorComponentProps) {
  useEffect(() => { Sentry.captureException(error) }, [error])
  return (
    <div className="p-8 text-center text-gray-600">
      Failed to load helper app settings.{' '}
      <button onClick={() => window.location.reload()} className="text-brand underline">
        Retry
      </button>
    </div>
  )
}

export const Route = createFileRoute('/settings/helper-app')({
  head: () => ({
    meta: [{ title: 'Helper App | Unbreakable' }],
  }),
  errorComponent: HelperAppError,
  component: HelperAppPage,
})

function HelperAppPage() {
  return (
    <AuthGuard>
      <HelperAppClient />
    </AuthGuard>
  )
}
